export default __webpack_public_path__ + "static/media/placeholder_store01-it-web.b325a54f.png";